import type { JoinProInfoPageType } from '@presentation/pages';
import agendaImage from './agenda.webp';
import agenda1 from './agenda/section1.webp';
import agenda2 from './agenda/section2.webp';
import agenda3 from './agenda/section3.webp';
import bookingImage from './booking.webp';
import booking1 from './booking/section1.webp';
import booking2 from './booking/section2.webp';
import booking3 from './booking/section3.webp';
import profileImage from './profile.webp';
import profile1 from './profile/section1.webp';
import profile2 from './profile/section2.webp';
import profile3 from './profile/section3.webp';
import profile4 from './profile/section4.webp';
import seoImage from './seo.webp';
import seo1 from './seo/section1.webp';
import seo2 from './seo/section2.webp';
import seo3 from './seo/section3.webp';

export const CARD_IMAGE_PER_TYPE: Record<JoinProInfoPageType, string> = {
  AGENDA: agendaImage,
  BOOKING: bookingImage,
  PROFILE: profileImage,
  SEO: seoImage,
};

export const SECTION_IMAGES_PER_TYPE: Record<JoinProInfoPageType, string[]> = {
  AGENDA: [agenda1, agenda2, agenda3],
  BOOKING: [booking1, booking2, booking3],
  PROFILE: [profile1, profile2, profile3, profile4],
  SEO: [seo1, seo2, seo3],
};
